import VideoEmbed from './videoEmbed.component';

export default VideoEmbed;
